var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "rb-snack-bar",
    { on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler } },
    [
      _c(
        "div",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _vm.hotels.length == 1
            ? [
                _c("b", [_vm._v(_vm._s(_vm.hotels[0].company.name))]),
                _vm._v(
                  " was just " +
                    _vm._s(_vm.action == "add" ? "added to" : "removed from") +
                    " your hotel directory. "
                ),
              ]
            : [
                _c("b", [_vm._v(_vm._s(_vm.hotels.length) + " hotels")]),
                _vm._v(
                  " were just " +
                    _vm._s(_vm.action == "add" ? "added to" : "removed from") +
                    " your hotel directory "
                ),
              ],
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "snackbar-buttons",
          attrs: { slot: "actions" },
          slot: "actions",
        },
        [
          _c(
            "button",
            {
              staticClass: "snackbar-button",
              attrs: { type: "button" },
              on: { click: _vm.undo },
            },
            [_vm._v(" UNDO ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }